/* istanbul ignore file */
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { DeleteButton } from 'framework/ui/ui-builder';
import { DELETE_BUDGET, useBudgetService } from 'domain/shared/budget';
import { useBudgetUrl } from 'domain/shared/budget';
import { Checkbox, FormFieldsData } from 'framework/form';
import { HTTP } from 'framework/api';
import Box from '@mui/material/Box';

const deleteMessage = 'Do you really want to delete this budget?';

const DeleteBudgetButton = () => {
  const { id: budgetId } = useParams<Dictionary<string>>();
  const { deleteBudget } = useBudgetService();
  const { getListUrl } = useBudgetUrl();
  const [withChildBudgets, setWithChildBudgets] = useState(false);

  const onCheckboxChange = (values: FormFieldsData) => {
    setWithChildBudgets(values.withChildBudgets);
  };

  return (
    <DeleteButton
      modalChildren={
        <Box
          sx={{
            marginTop: 3,
            '& span': {
              fontStyle: 'italic',
            },
            '& .form-group': {
              marginBottom: '0 !important',
            },
          }}
        >
          <Checkbox
            source="withChildBudgets"
            value={withChildBudgets}
            label="Remove child budgets too"
            onChangeCallback={onCheckboxChange}
          />
        </Box>
      }
      deleteMethod={() => deleteBudget(budgetId!, withChildBudgets)}
      displayMessage={deleteMessage}
      afterDelete={{
        redirectUrl: getListUrl(),
        successMessage: 'The Budget has been successfully deleted.',
        errorMessage: `Can't delete budget`,
        errorStatusesMessages: {
          [HTTP.BAD_REQUEST]: 'Budget assigned to a Project cannot be deleted.',
        },
      }}
      permissionToCheck={DELETE_BUDGET}
    />
  );
};

export default DeleteBudgetButton;
